import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "ui basic unstackable table",
  id: "table"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { id: "status4" }, "🏆状态"),
    /*#__PURE__*/_createElementVNode("th", { id: "xieyi" }, "🔗协议"),
    /*#__PURE__*/_createElementVNode("th", { id: "name" }, "📌节点"),
    /*#__PURE__*/_createElementVNode("th", { id: "type" }, "💻系统"),
    /*#__PURE__*/_createElementVNode("th", { id: "location" }, "🌍位置"),
    /*#__PURE__*/_createElementVNode("th", { id: "uptime" }, "⏱️在线"),
    /*#__PURE__*/_createElementVNode("th", { id: "load" }, "⏳负载"),
    /*#__PURE__*/_createElementVNode("th", { id: "network" }, "🚦网络(B/s) ↓|↑"),
    /*#__PURE__*/_createElementVNode("th", { id: "traffic" }, "📋总流量(B) ↓|↑"),
    /*#__PURE__*/_createElementVNode("th", { id: "tongji" }, "🟢统计流量(B) ↓|↑"),
    /*#__PURE__*/_createElementVNode("th", { id: "cpu" }, "🎯CPU"),
    /*#__PURE__*/_createElementVNode("th", { id: "ram" }, "⚡️内存"),
    /*#__PURE__*/_createElementVNode("th", { id: "hdd" }, "💾硬盘")
  ])
], -1)
const _hoisted_3 = { id: "servers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_item = _resolveComponent("table-item")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servers, (server, index) => {
        return (_openBlock(), _createBlock(_component_table_item, {
          key: index,
          server: server
        }, null, 8, ["server"]))
      }), 128))
    ])
  ]))
}